import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { DateFormat, CurrencyFormat, PercentFormat, FormatISODateTime, formatApr } from '../../../helpers/formatting'

export default function LeadTermOverrideForm(props) {
  const { control, responseData, actionDisabled } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link to={`user/${responseData?.agent_user_id}`} className="is-link" target="_blank"><b>{responseData?.agent_user_label}</b></Link> requested manager approval for a lead term override for customer <Link to={`customer/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.customer_label}</b></Link> for Lead <Link to={`payment_schedule/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.lead?.label}</b></Link>.
      </h3>
      <h3>{responseData?.description}</h3>

      <div className="column" style={{ maxHeight: "400px", overflow: "auto" }}>
        <div className="columns mb-0 is-flex-direction-column">
          <div className="column">
            {responseData?.payment_schedule && (
              <>
                <div className="columns is-multiline">
                  <div className="column is-half">
                    <p className={`${((responseData?.pti_audit?.min_principal && +responseData?.lead?.principal_amount < +responseData?.pti_audit?.min_principal) || (responseData?.pti_audit?.max_principal && +responseData?.lead?.principal_amount > +responseData?.pti_audit?.max_principal)) ? "has-text-danger" : ""}`}><strong>Principal:</strong> <CurrencyFormat value={responseData?.lead?.principal_amount} /></p>
                    <p className={`${((responseData?.pti_audit?.min_apr && +responseData?.lead?.apr < +responseData?.pti_audit?.min_apr) || (responseData?.pti_audit?.max_apr && +responseData?.lead?.apr > +responseData?.pti_audit?.max_apr)) ? "has-text-danger" : ""}`}><strong>APR:</strong> {formatApr(responseData?.lead?.apr)}%</p>
                    <p className={`${(responseData?.pti_audit?.max_payment_amount && +responseData?.payment_schedule[0]?.payment > +responseData?.pti_audit?.max_payment_amount) ? "has-text-danger" : ""}`}><strong>Payment Amount:</strong> <CurrencyFormat value={responseData?.payment_schedule[0]?.payment} /></p>
                  </div>
                  <div className="column is-half">
                    <p><strong>PTI (Min/Max): </strong> <CurrencyFormat value={responseData?.pti_audit?.min_principal} />/<CurrencyFormat value={responseData?.pti_audit?.max_principal} /></p>
                    <p><strong>PTI (Min/Max): </strong> {formatApr(responseData?.pti_audit?.min_apr)}%/{formatApr(responseData?.pti_audit?.max_apr)}%</p>
                    <p><strong>PTI (Max): </strong><CurrencyFormat value={responseData?.pti_audit?.max_payment_amount} /></p>
                  </div>
                </div>
                <div className="columns is-multiline">
                  <div className="column is-half">
                    <p><strong>Total Amount:</strong> <CurrencyFormat value={responseData?.lead?.approved_total_amount} /></p>
                    <p><strong>Total Interest:</strong> <CurrencyFormat value={responseData?.lead?.approved_interest_amount} /></p>
                  </div>
                  <div className="column is-half">
                    <p><strong>Effective Date:</strong> <DateFormat dateString={responseData?.lead?.effective_date} /></p>
                    <p><strong>Interest Rate:</strong> {parseFloat(responseData?.lead?.interest_rate).toFixed(2)}%</p>
                  </div>
                </div>
                <div className="table-container">
                  <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth is-grey mb-3">
                    <thead>
                      <tr>
                        <th colSpan="5" className="is-selected has-text-left lox-payment-schedule-color">Payment Schedule</th>
                      </tr>
                      <tr>
                        <th className="is-selected has-text-centered lox-payment-schedule-color">
                          #
                        </th>
                        <th className="is-selected has-text-centered lox-payment-schedule-color">
                          Date
                        </th>
                        <th className="is-selected has-text-centered lox-payment-schedule-color">
                          Principal $
                        </th>
                        <th className="is-selected has-text-centered lox-payment-schedule-color">
                          Interest $
                        </th>
                        <th className="is-selected has-text-centered lox-payment-schedule-color">
                          Total $$$
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {responseData?.payment_schedule?.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <tr key={index}>
                          <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>{index + 1}</td>
                          <td
                            className="has-text-left"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <DateFormat dateString={item.date} />
                          </td>
                          <td
                            className="has-text-left"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <CurrencyFormat value={+item.principal_amount} />
                          </td>
                          <td
                            className="has-text-left"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <CurrencyFormat value={+item.payment - +item.principal_amount} />
                          </td>
                          <td
                            className="has-text-left"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <CurrencyFormat value={+item.payment} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <thead>
                      <tr>
                        <th colSpan="2" className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>TOTAL PLAN</th>
                        <th className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>
                          <CurrencyFormat value={responseData?.payment_schedule?.reduce((total, item) => total + +item.principal_amount, 0)} />
                        </th>
                        <th className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>
                          <CurrencyFormat value={responseData?.payment_schedule?.reduce((total, item) => total + (+item.payment - +item.principal_amount), 0)} />
                        </th>
                        <th className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>
                          <CurrencyFormat value={responseData?.payment_schedule?.reduce((total, item) => total + +item.payment, 0)} />
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* TODO: Future Update: Add back ability for managers to update values for lead term override, for now only approve or decline */}
      {/*<div className="divider m-0 my-2"></div>*/}

      {/*<h3>If approving you may modify these values:</h3><br />*/}

      {/*<div className="field is-horizontal manager-approval-modal-field">*/}
      {/*  <label className={`manager-approval-modal-label`}>Approved Principal:</label>*/}
      {/*  <Controller*/}
      {/*    name="principal_amount"*/}
      {/*    control={control}*/}
      {/*    defaultValue={responseData?.lead?.principal_amount ?? 0}*/}
      {/*    rules={{ required: true }}*/}
      {/*    render={({ field }) => (*/}
      {/*      <input {...field} type="number" className="input is-small" disabled={actionDisabled} />*/}
      {/*    )}*/}
      {/*  />*/}
      {/*</div>*/}

      {/*<div className="field is-horizontal manager-approval-modal-field">*/}
      {/*  <label className={`manager-approval-modal-label`}>APR:</label>*/}
      {/*  <Controller*/}
      {/*    name="apr"*/}
      {/*    control={control}*/}
      {/*    defaultValue={responseData?.lead?.apr ?? 0}*/}
      {/*    rules={{ required: true }}*/}
      {/*    render={({ field }) => (*/}
      {/*      <input {...field} type="number" className="input is-small" disabled={actionDisabled} />*/}
      {/*    )}*/}
      {/*  />*/}
      {/*</div>*/}
    </>
  )
}
